export default __webpack_public_path__ + "static/media/timeline_page_framed.4c782dd1.png";